import { SLACK_URL } from "./globalExternalURLs";

export let slackURLCorrection = (url) => {
  let newUrl = url;
  if (!url.includes("slack.com")) {
    newUrl = SLACK_URL + url;
  }
  return newUrl;
};
